import { useState } from "react";
import { adminService } from "services/adminService";

export default function useAdminService() {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const createOrUpdateKnowledgeDocument = async (knowledgeDocument) => {
    try {
      setLoading(true);
      const response = await adminService.createOrUpdateKnowledgeDocument(knowledgeDocument);
      if (response.error) {
        setError(response.error);
      }
      return response;
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getKnowledgeDocumentById = async (knowledgeDocumentId) => {
    try {
      setLoading(true);
      const response = await adminService.getKnowledgeDocumentById(knowledgeDocumentId);
      if (response.error) {
        setError(response.error);
      }
      return response;
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteKnowledgeDocumentById = async (knowledgeDocumentId) => {
    try {
      setLoading(true);
      const response = await adminService.deleteKnowledgeDocumentById(knowledgeDocumentId);
      if (response.error) {
        setError(response.error);
      }
      return response;
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getAllKnowledgeDocumentSummaries = async () => {
    try {
      setLoading(true);
      const response = await adminService.getAllKnowledgeDocumentSummaries();
      if (response.error) {
        setError(response.error);
      }
      return response;
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    error,
    createOrUpdateKnowledgeDocument,
    getKnowledgeDocumentById,
    deleteKnowledgeDocumentById,
    getAllKnowledgeDocumentSummaries,
    loading,
  };
}
